import React from "react";
import { GridItem, GridContainer } from "./MerchantAndTerminals.styles";
import TextField from "../../textField/TextField";

const MerchantFields = ({
  formValues,
  handleChange,
  handleBlur,
  errors,
  touched,
  readOnly = false,
}) => {
  const {
    acquirer: { surcharge = "0" },
    merchant: { amount_tx_processing, percent_tx_processing },
  } = formValues;

  return (
    <GridContainer>
      <GridItem xs={12} md={6} padding="15px 15px 15px 0">
        <TextField
          id="merchant.amount_tx_processing"
          name="merchant.amount_tx_processing"
          fullWidth
          label="Processing Transaction Fee"
          value={amount_tx_processing}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          // type="number"
          placeholder="0.00"
          error={errors.merchant?.amount_tx_processing}
          touched={touched.merchant?.amount_tx_processing}
          disabled={readOnly}
        />
      </GridItem>
      <GridItem xs={12} md={6} padding="15px 15px 15px 0">
        <TextField
          id="merchant.percent_tx_processing"
          name="merchant.percent_tx_processing"
          fullWidth
          label="MDR Percentage Fee"
          value={percent_tx_processing}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          // type="number"
          placeholder="0.0000"
          error={errors.merchant?.percent_tx_processing}
          touched={touched.merchant?.percent_tx_processing}
          disabled={readOnly}
        />
      </GridItem>
      <GridItem xs={12} md={6} padding="15px 15px 15px 0">
        <TextField
          id="acquirer.surcharge"
          name="acquirer.surcharge"
          fullWidth
          label="Surcharge"
          value={surcharge}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          // type="number"
          placeholder="0"
          error={errors.acquirer?.surcharge}
          touched={touched.acquirer?.surcharge}
          disabled={readOnly}
        />
      </GridItem>
      <GridItem xs={12} md={6} />
      <GridItem xs={12} md={6} />
    </GridContainer>
  );
};

export default MerchantFields;
